import React, { useState, useEffect } from "react";
import { CautionIcon, HeartIcon, QuestionMarkIcon, SearchIcon } from "~/assets/svg/InterfaceIcon";

import darkLogoImg from "~/assets/img/defaultImg/dark-logo-square.png";
import lightLogoImg from "~/assets/img/defaultImg/light-logo-square.png";
import darkNewsImg from "~/assets/img/defaultImg/dark-default-rec.png";
import lightNewsImg from "~/assets/img/defaultImg/light-default-rec.png";

import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import ImageSlider from "~/common/components/ImageSlider";
import useRequest from "~/common/hooks/useRequest";
import Pagination from "./util/Pagination";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import { useNavigate } from "react-router";
import TabMenu from "~/common/components/TabMenu";
import { Case, If } from "~/common/components/If";
import { API_STATE } from "~/common/constants/state";
import { WarningIcon } from "~/assets/svg/AlertIcon";
import { thousandFormatter, convertToBillion } from "~/utils/formatter";
import LoadingPage from "~/pages/LoadingPage";
import pageMaker from "~/common/constants/pageMaker";
import { getTitle } from "~/utils/getTitle";
import { Helmet } from "react-helmet-async";
import TrendChart from "~/common/components/TrendChart";
import { useTranslation } from "react-i18next";
import i18n from "~/i18n";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";
import { INVEST_LEVEL } from "~/constant/ApplyFormConstant";
import { useSearchParams } from "react-router-dom";

const InvestListTable = ({
	pageInfo,
	companyList,
	handlePage,
	onChangeName,
	handleSearch,
	resetList,
	curTab,
	setCurTab,
	setCurPage,
	loadingPage,
}) => {
	const { t } = useTranslation();

	const [detailModal, setDetailModal] = useState(false);
	const [companyDetail, setCompanyDetail] = useState({});
	const [product, setProduct] = useState("");
	const [tags, setTags] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [subModal, setSubModal] = useState(false);
	const [investStat, setInvestStat] = useState({});
	const [investAttract, setInvestAttract] = useState([]);
	const [similarProductList, setSimilarProductList] = useState([]);

	const favoriteActionApi = useRequest("post", `vc/invest/favorite/add`);
	const favoriteSubActionApi = useRequest("delete", `vc/invest/favorite`);
	const investStatApi = useRequest("get", "vc/invest/check");
	const investAttractApi = useRequest("get", "vc/invest/startupCompany");
	const viewStartupRequest = useRequest("put", "vc/company/startup/view");

	const [searchParams] = useSearchParams();
	const modalIdx = searchParams.get("modalIdx");

	const [
		{
			company: { info },
			sidebar: { currentPath },
			theme: { theme },
		},
	] = useGlobalStore();

	const navigate = useNavigate();

	const [showAuthAlert, AuthAlert] = useAlert();
	const [showNoInfoAlert, NoInfoAlert] = useAlert();


	const detailIdx = investStat?.data;
	const [newsData, setNewsData] = useState({});

	const [newsPageData, setNewsPageData] = useState({
		page: newsData?.pageable?.pageNumber + 1 || 1,
		size: 5,
	});
	const similarProductSize = 20;

	const newsDataPage = pageMaker(newsPageData.page, newsPageData.size, newsData?.totalElements);
	const handleNewsPage = (pageNum) => {
		setCurPage(pageNum);
		setNewsPageData({ ...newsPageData, page: pageNum });
	};
	const newsRequest = useRequest(
		"patch",
		`news-search/news/search?page=${newsPageData.page}&size=${newsPageData.size}`,
		"em"
	);

	const similarProductRequest = useRequest(
		"post",
		`company-search/company/similar-company`,
		"em"
	);
	const similarProductImgRequest = useRequest("patch", `/company/num`, "em");

	const similarCompanyStepRequest = useRequest("post", "vc/invest/startupCompany");

	useEffect(() => {
		newsRequest.call({ title: companyDetail?.name });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [newsPageData]);

	function isEmptyObj(obj) {
		return obj.constructor === Object && Object.keys(obj).length === 0;
	}

	//상세 페이지
	const companyDetailModal = (idx) => {
		if (currentPath.auth !== "edit") {
			showAuthAlert();
			return;
		}
		const detail = companyList.find((d) => d.idx === idx);
		const products =
			detail?.CompanyProduct.length > 0
				? detail?.CompanyProduct.find((product) => product.representation === true)
				: {
					CompanyProductImage: [],
					CompanyProductKeyword: [],
					description: (
						<div className="no-data">
							<WarningIcon />
							<p>
								{t("pages.investment.InvestListPage.InvestListTable.noData01")}
							</p>
						</div>
					),
					name: "미정",
					representation: false,
				};

		const tags =
			products.CompanyProductKeyword.sort((prev, cur) => {
				return prev.idx - cur.idx;
			})?.slice(0, 5) || [];
		investStatApi.call(idx, "path");
		investAttractApi.call(idx, "path");
		similarProductRequest.call(
			{
				keywordList: tags.map((tag) => {
					return tag.content;
				}),
				bizNum: detail?.regNum,
				size: similarProductSize,
			},
			"body"
		);
		setCurrentTab("desc");
		setProduct(products);
		setTags(tags);
		setCompanyDetail(detail);
		setDetailModal(true);
		newsRequest.call({ title: detail?.name });
		viewStartupRequest.call(idx, "path");
	};

	useEffect(() => {
		switch (investStatApi.state) {
			case API_STATE.done:
				const requestCompanyData = investStatApi.response;
				setInvestStat(requestCompanyData);
				break;
			default:
				break;
		}
	}, [investStatApi.state, investStatApi.response, setInvestStat]);

	useEffect(() => {
		switch (investAttractApi.state) {
			case API_STATE.done:
				const requestCompanyData = investAttractApi.response.data;

				function groupDataByMonth(data) {
					const groupedData = [];
					const monthMap = {};

					for (let i = 0; i < data?.name.length; i++) {
						const month = data.date[i].substring(0, 7);

						if (!monthMap[month]) {
							monthMap[month] = {
								name: [],
								step: [],
								value: [],
								date: month,
								comValue: [],
							};
						}

						monthMap[month]?.name.push(data?.name[i]);
						monthMap[month].step.push(data.step[i]);
						monthMap[month].value.push(parseInt(data.value[i]));
						monthMap[month].comValue.push(parseInt(data.comValue[i]));
					}

					for (const month in monthMap) {
						groupedData.push(monthMap[month]);
					}

					return groupedData;
				}
				isEmptyObj(requestCompanyData)
					? setInvestAttract([])
					: setInvestAttract(groupDataByMonth(requestCompanyData));
				break;
			default:
				break;
		}
	}, [investAttractApi.state, investAttractApi.response, setInvestAttract]);

	useEffect(() => {
		switch (similarProductRequest.state) {
			case API_STATE.done:
				const similarProductResponse = similarProductRequest.response?.data || [];

				const companyIdList = similarProductResponse.map((product) => {
					return product.id;
				});

				companyIdList.length > 0 && similarProductImgRequest.call({}, "body");

				similarCompanyStepRequest.call(
					{
						bizNumList: similarProductResponse.map((item) => item.biz_num),
					},
					"body"
				);

				setSimilarProductList(similarProductResponse);
				break;
			default:
				break;
		}
	}, [similarProductRequest.state, similarProductRequest.response, setNewsData]);

	useEffect(() => {
		switch (similarCompanyStepRequest.state) {
			case API_STATE.done:
				if (similarCompanyStepRequest.response.data.length === 0) {
					setSimilarProductList((prev) =>
						prev.map((item) => ({
							...item,
							investStep: "-",
							investValue: "-",
						}))
					);
					return;
				}
				setSimilarProductList((prev) =>
					prev.map((item) => ({
						...item,
						investStep:
							similarCompanyStepRequest.response.data[0].find(
								(data) => data.Company?.regNum === item.biz_num
							)?.step ?? "-",
						investValue:
							similarCompanyStepRequest.response.data[0].reduce((acc, curr) => {
								if (curr.Company?.regNum === item.biz_num) {
									acc += Number(curr.value);
								}
								return acc;
							}, 0) *
								1000 !==
								0
								? similarCompanyStepRequest.response.data[0].reduce((acc, curr) => {
									if (curr.Company?.regNum === item.biz_num) {
										acc += Number(curr.value);
									}
									return acc;
								}, 0) * 1000
								: "-",
					}))
				);
		}
	}, [similarCompanyStepRequest.state]);

	useEffect(() => {
		switch (newsRequest.state) {
			case API_STATE.done:
				const requestNewsApi = newsRequest.response;
				setNewsData(requestNewsApi.data);
				break;
			default:
				break;
		}
	}, [newsRequest.state, newsRequest.response, setNewsData]);

	//관심기업 등록
	const favoriteAction = (fav, idx) => {
		if (currentPath.auth !== "edit") {
			showAuthAlert();
			return;
		}
		if (!fav) {
			favoriteActionApi
				.asyncCall(idx, "path")
				.then(() => setAddModal(true))
				.then(() => resetList());
		} else {
			favoriteSubActionApi
				.asyncCall(idx, "path")
				.then(() => setSubModal(true))
				.then(() => resetList());
		}
	};

	//탭 변경
	const changeTab = () => {
		setCurPage(1);
		if (curTab === "all") {
			setCurTab("favorite");
		} else {
			setCurTab("all");
		}
	};

	// 모달 내부 탭메뉴
	const [currentTab, setCurrentTab] = useState("desc");
	const tabMenuList = [
		{
			id: "desc",
			title: i18n.t("pages.investment.InvestListPage.InvestListTable.tabMenuList.title01"),
		},
		{
			id: "attract",
			title: i18n.t("pages.investment.InvestListPage.InvestListTable.tabMenuList.title02"),
		},
		{
			id: "press",
			title: i18n.t("pages.investment.InvestListPage.InvestListTable.tabMenuList.title03"),
		},
		{
			id: "similar",
			title: i18n.t("pages.investment.InvestListPage.InvestListTable.tabMenuList.title04"),
		},
	];

	//투자심사 요청
	const moveInvestRequest = (idx) => {
		navigate(`/invest/evaluate/request/${idx}`);
	};

	useEffect(() => {
		resetList();
	}, [curTab]);

	useEffect(() => {
		setNewsData();
		setNewsPageData({ ...newsPageData, page: 1 });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [detailModal]);

	useEffect(() => {
		if (!companyList) return;
		if (!modalIdx) return;
		companyDetailModal(Number(modalIdx));
	}, [companyList]);

	function add(arr) {
		return arr.reduce((a, b) => a + b, 0);
	}

	const dataset = investAttract.map((invest) => {
		return { date: invest.date, investValue: add(invest.value) };
	});

	const investSum = dataset.reduce((accumulator, current) => {
		return Number(accumulator) + Number(current.investValue);
	}, 0);

	function toDate(date_str) {
		const yyyyMMdd = String(date_str);
		const sYear = yyyyMMdd.substring(0, 4);
		const sMonth = yyyyMMdd.substring(5, 7);
		const sDate = yyyyMMdd.substring(8, 10);

		return new Date(Number(sYear), Number(sMonth) - 1, Number(sDate));
	}

	const linkAddHttp = (link) => {
		if (link === "" || !link.includes(".") || link === "-") return null;
		if (link.includes("http")) return link;
		return `https://${link}`;
	};

	const { height, data, mapTable, xAxisKey } = {
		height: 300,
		data: [...dataset],
		mapTable: {
			investValue: {
				detail: investAttract,
				color: "#6b44ff",
				type: "bar",
			},
		},
		xAxisKey: "date",
	};

	return (
		<>
			<div className="c__card filterList-card">
				<div className="list-top">
					<div className="list-title">
						<p className="sub-title">
							{t("pages.investment.InvestListPage.InvestListTable.title")}
							<div className="c__tooltip-btn">
								<QuestionMarkIcon />
								<p className="c__tooltip">
									깃발 스타트업을 이용하고 있는 기업의 목록을 확인할 수 있습니다.
									<br />
									기업명을 누르면 기업의 기본 정보, 키워드, 제품 설명, 투자유치,
									보도자료, 유사업체를 확인할 수 있으며 투자 심사 요청으로
									간편하고 빠르게 IR 자료를 공유 받아 투자 심사를 진행할 수
									있습니다.
									<br />
									<br />
									관심 기업 : 목록에서 기업 정보를 확인 후 [♥]를 눌러 관심 있는
									기업만 따로 리스트업 할 수 있습니다.
								</p>
							</div>
						</p>
						<ol className="filter-route">
							<li
								className={curTab === "all" ? "active" : ""}
								onClick={() => changeTab()}
							>
								ALL
							</li>
							<li
								className={curTab === "favorite" ? "active" : ""}
								onClick={() => changeTab()}
							>
								{t("pages.investment.InvestListPage.InvestListTable.filter")}
							</li>
						</ol>
					</div>
					<div className="c__search">
						<input
							className="c__input"
							placeholder={t(
								"pages.investment.InvestListPage.InvestListTable.placeholder"
							)}
							onChange={onChangeName}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									handleSearch();
								}
							}}
						/>
						<button type="button" className="btn-search" onClick={handleSearch}>
							<SearchIcon />
						</button>
					</div>
				</div>

				{!loadingPage ? (
					<>
						<div className="c__table">
							<div className="thead">
								<div className="tr">
									<div className="th company-wrap">
										{t(
											"pages.investment.InvestListPage.InvestListTable.tableHeading01"
										)}
									</div>
									<div className="th company-info">
										{t(
											"pages.investment.InvestListPage.InvestListTable.tableHeading02"
										)}
									</div>
									<div className="th company-product">
										{t(
											"pages.investment.InvestListPage.InvestListTable.tableHeading03"
										)}
									</div>
									<div className="th company-tag">
										{t(
											"pages.investment.InvestListPage.InvestListTable.tableHeading04"
										)}
									</div>
								</div>
							</div>
							<div className="tbody">
								{companyList && companyList.length > 0 ? (
									companyList.map((item) => {
										const seedInfo = !item.CompanyInvestInfo.target
											? " - "
											: item.CompanyInvestInfo.target > 10000000
												? (item.CompanyInvestInfo.target / 100000000).toFixed(
													1
												) +
												t(
													"pages.investment.InvestListPage.InvestListTable.unit01"
												)
												: item.CompanyInvestInfo.target > 1000000
													? item.CompanyInvestInfo.target.substring(0, 1) +
													t(
														"pages.investment.InvestListPage.InvestListTable.unit02"
													)
													: thousandFormatter(item.CompanyInvestInfo.target) +
													t(
														"pages.investment.InvestListPage.InvestListTable.unit03"
													);

										return (
											<div
												className={
													item.favorite === false ? "tr" : "tr favorite"
												}
												key={item.idx}
												onClick={() => {
													companyDetailModal(item.idx);
												}}
											>
												<div className="td company-wrap">
													<div
														className="company-favorite"
														onClick={(event) => {
															event.stopPropagation();
															favoriteAction(item.favorite, item.idx);
														}}
													>
														<HeartIcon />
													</div>
													<div className="company-profile">
														<div className="img-wrap">
															<img
																src={
																	item?.logoSqu ||
																	(theme === "dark"
																		? darkLogoImg
																		: lightLogoImg)
																}
																alt={t(
																	"pages.investment.InvestListPage.InvestListTable.imageAlt01"
																)}
															/>
														</div>
													</div>
													<div className="company-name">{item?.name}</div>
												</div>
												<div className="td company-info">
													{item?.address
														? item?.address?.substring(0, 2)
														: "-"}{" "}
													/{" "}
													{new Date().getFullYear() -
														parseInt(item.estDate?.substring(0, 4)) +
														1}
													년차 /{" "}
													{INVEST_LEVEL.find(
														(value) =>
															value.value ===
															item?.CompanyInvestInfo?.round
													)?.label || "-"}{" "}
													/ {`seed (${seedInfo})`}
												</div>
												<div className="td company-product">
													{item?.CompanyProduct.length > 0 &&
														item?.CompanyProduct.find(
															(product) =>
																product.representation === true
														)?.name}
												</div>
												<div className="td company-tag">
													{item?.CompanyProduct.find(
														(product) => product.representation
													)?.CompanyProductKeyword.map((tag) => (
														<span>#{tag.content}</span>
													))}
												</div>
											</div>
										);
									})
								) : //---- Empty
									curTab === "favorite" ? (
										<div className="c__noData">
											<CautionIcon />
											<p className="main">
												{t(
													"pages.investment.InvestListPage.InvestListTable.main01"
												)}
											</p>
											<p className="sub">
												{t(
													"pages.investment.InvestListPage.InvestListTable.sub01"
												)}
											</p>
										</div>
									) : (
										<div className="c__noData">
											<CautionIcon />
											<p className="main">
												{t(
													"pages.investment.InvestListPage.InvestListTable.main02"
												)}
											</p>
											<p className="sub">
												{t(
													"pages.investment.InvestListPage.InvestListTable.sub02"
												)}
											</p>
										</div>
									)}
							</div>
						</div>
						<Pagination pageInfo={pageInfo} handlePage={handlePage} />
					</>
				) : (
					<LoadingPage />
				)}
			</div>

			<ModalTemplate
				modalState={detailModal}
				setModalToggle={setDetailModal}
				title={companyDetail?.name}
				with={1100}
				className="modal-companyDetail"
			>
				<Helmet>
					<title>
						{getTitle(
							`${t("pages.investment.InvestListPage.InvestListTable.modalTitle")}}/${companyDetail?.name
							}`
						)}
					</title>
				</Helmet>
				<div className="modal-content">
					<section className="header-section">
						<div>
							<div className="product-name">{product?.name}</div>
							<div className="c__tag-wrap">
								{tags
									? tags.map((d, idx) => (
										<span className="c__tag-view" key={idx}>
											{d.content}
										</span>
									))
									: ""}
							</div>
						</div>
						<div className="attract-wrap">
							<dl className="round-name">
								<dt>
									{INVEST_LEVEL.find(
										(value) =>
											value.value === companyDetail?.CompanyInvestInfo?.round
									)?.label ?? "-"}
								</dt>
								<dd className="status-wrap">
									{companyDetail?.CompanyInvestInfo?.status === "0"
										? t(
											"pages.investment.InvestListPage.InvestListTable.status01"
										)
										: t(
											"pages.investment.InvestListPage.InvestListTable.status02"
										)}
								</dd>
							</dl>
							<dl className="company-invest">
								<dt>
									{t("pages.investment.InvestListPage.InvestListTable.label01")}
								</dt>
								<dd>
									<span className="amount">
										{companyDetail?.CompanyInvestInfo?.target
											? thousandFormatter(
												companyDetail?.CompanyInvestInfo?.target
											)
											: "-"}
									</span>
									<span className="unit">
										{t(
											"pages.investment.InvestListPage.InvestListTable.unit04"
										)}
									</span>
								</dd>
							</dl>
						</div>
					</section>
					<section className="info-section">
						<div className="product-slider">
							<ImageSlider list={product.CompanyProductImage}>
								{/* {product.CompanyProductImage.map((d, idx) => (
									<div key={idx}>
										<img src={d.img} alt={"기업 이미지"} />
									</div>
								))} */}
							</ImageSlider>
						</div>
						<div className="company-info">
							<div className="header">
								<div className="img-wrap">
									<img
										src={
											companyDetail?.logoSqu
												? companyDetail?.logoSqu
												: theme === "dark"
													? darkLogoImg
													: lightLogoImg
										}
										alt={t(
											"pages.investment.InvestListPage.InvestListTable.imageAlt01"
										)}
									/>
									{/*<img src={lightLogoImg} alt="기본로고이미지" />*/}
								</div>
								<dl className="company-name">
									<dt>{companyDetail?.name}</dt>
									<dd>{companyDetail?.homepage}</dd>
								</dl>
							</div>
							<dl className="info">
								<div>
									<dt>
										{t(
											"pages.investment.InvestListPage.InvestListTable.label02"
										)}
									</dt>
									<dd>
										{companyDetail?.estDate
											? companyDetail?.estDate.substring(0, 10)
											: "-"}
									</dd>
								</div>
								<div>
									<dt>
										{t(
											"pages.investment.InvestListPage.InvestListTable.label03"
										)}
									</dt>
									<dd>{companyDetail?.employeeNum}</dd>
								</div>
								<div>
									<dt>
										{t(
											"pages.investment.InvestListPage.InvestListTable.label04"
										)}
									</dt>
									<dd>{companyDetail?.certType}</dd>
								</div>
								<div>
									<dt>
										{t(
											"pages.investment.InvestListPage.InvestListTable.label05"
										)}
									</dt>
									<dd>{companyDetail?.country}</dd>
								</div>
								<div>
									<dt>
										{t(
											"pages.investment.InvestListPage.InvestListTable.label06"
										)}
									</dt>
									<dd>{companyDetail?.bizType}</dd>
								</div>
								<div>
									<dt>
										{t(
											"pages.investment.InvestListPage.InvestListTable.label07"
										)}
									</dt>
									<dd>
										{companyDetail?.listed
											? t("pages.applyFormMange.modals.stocks.selectOption1")
											: t("pages.applyFormMange.modals.stocks.selectOption2")}
									</dd>
								</div>
								<div>
									<dt>
										{t(
											"pages.investment.InvestListPage.InvestListTable.label08"
										)}
									</dt>
									<dd>
										{companyDetail?.sales
											? thousandFormatter(companyDetail.sales) +
											t("pages.applyFormMange.modals.unit")
											: "-"}
									</dd>
								</div>
								<div>
									<dt>
										{t(
											"pages.investment.InvestListPage.InvestListTable.label09"
										)}
									</dt>
									<dd>{companyDetail?.address}</dd>
								</div>
							</dl>
							<div className="company-state">
								{/* <div className="requested">
									<p>심사요청이 완료되었습니다.</p>
									<button type="button" className="btn-evaluate">
										심사 바로가기
									</button>
								</div> */}
								{(investStat && investStat.data && investStat.data.length === 0) ||
									(investStat?.data && investStat.data[0].status === "완료") ||
									(investStat &&
										investStat.data &&
										investStat.data[0].status === "반려") ? (
									<button
										type="button"
										className="btn__solid"
										color="primary"
										onClick={() => {
											if (currentPath.auth !== "edit") {
												showAuthAlert();
												return;
											}
											if (info.name === '-') {
												showNoInfoAlert().then(() => navigate(
													'/vc/info?edit=true'
												));
												return
											}
											moveInvestRequest(companyDetail.idx);
										}}
									>
										{t(
											"pages.investment.InvestListPage.InvestListTable.button01"
										)}
									</button>
								) : (
									<div className="requested">
										<p>
											{t(
												"pages.investment.InvestListPage.InvestListTable.request"
											)}
										</p>
										<button
											type="button"
											className="btn-evaluate"
											onClick={() =>
												navigate(
													detailIdx
														? `/invest/evaluate/detail/${detailIdx[0]?.idx}`
														: "/invest/list"
												)
											}
										>
											{t(
												"pages.investment.InvestListPage.InvestListTable.button02"
											)}
										</button>
									</div>
								)}
							</div>
						</div>
					</section>
					<section className="content-section">
						<TabMenu
							tabItem={tabMenuList}
							currentTab={currentTab}
							setCurrentTab={setCurrentTab}
						/>
						<If condition={currentTab}>
							<Case condition={"desc"}>
								{product?.description ? (
									<div className="product-desc">
										{product.description &&
											typeof product.description === "string" &&
											product.description.split("\n").map((text, index) => {
												return (
													<span key={index}>
														{text}
														<br />
													</span>
												);
											})}
									</div>
								) : (
									<div className="product-desc">
										<div className="no-data">
											<WarningIcon />
											<p>
												{t(
													"pages.investment.InvestListPage.InvestListTable.noData01"
												)}
											</p>
										</div>
									</div>
								)}
							</Case>
							<Case condition={"attract"}>
								<div className="invest-attract">
									{investAttract.length < 1 ? (
										<p className="no-data">
											{t(
												"pages.investment.InvestListPage.InvestListTable.noData02"
											)}
										</p>
									) : (
										<>
											<div className="chart">
												<h2>
													{t(
														"pages.investment.InvestListPage.InvestListTable.chart"
													)}{" "}
													: {convertToBillion(investSum * 1000)}
												</h2>
												<TrendChart
													{...{ data, mapTable, xAxisKey, height }}
												/>
											</div>
											<div className="timeline-wrap">
												<ol>
													{investAttract.map((invest) => (
														<li className="timeline-item">
															<span className="timeline-date">
																{invest.date}
															</span>
															<ul className="timeline-content">
																<li>
																	<ul className="vc-invest-history">
																		{invest?.name.map(
																			(name, index) => (
																				<li>
																					{name}{" "}
																					{
																						invest
																							.value[
																						index
																						]
																					}{" "}
																					(
																					{
																						invest.step[
																						index
																						]
																					}
																					)
																				</li>
																			)
																		)}
																	</ul>
																</li>
															</ul>
														</li>
													))}
												</ol>
											</div>
										</>
									)}
								</div>
							</Case>
							<Case condition={"press"}>
								<div className="press-release">
									{newsData && newsData.content?.length > 0 ? (
										<>
											<ul className="news-list">
												{newsData.content.map((n, index) => {
													return (
														<li
															key={index}
															onClick={() => window.open(n.url)}
														>
															<div className="img-wrap">
																<img
																	src={
																		n.image_url !== "no image"
																			? n.image_url
																			: theme === "dark"
																				? darkNewsImg
																				: lightNewsImg
																	}
																	alt={t(
																		"pages.investment.InvestListPage.InvestListTable.imageAlt02"
																	)}
																/>
																{/*<img src={lightNewsImg} alt="뉴스이미지" />*/}
															</div>
															<div className="news-data">
																<div className="news-header">
																	<p className="news-title">
																		{n.title}
																	</p>
																	<p className="news-text">
																		{n.content}
																	</p>
																</div>
																<div className="news-info">
																	<span>{n.portal}</span>
																	<span>
																		{n.create_date.substring(
																			0,
																			10
																		)}
																	</span>
																</div>
															</div>
														</li>
													);
												})}
												{/* <li>
											<div className="img-wrap">
												<img src={darkNewsImg} alt="뉴스이미지" />
											</div>
											<div className="news-data">
												<div className="news-header">
													<p className="news-title">제목</p>
													<p className="news-text">내용</p>
												</div>
												<div className="news-info">
													<span>서울경제</span>
													<span>2022-05-11</span>
												</div>
											</div>
										</li> */}
											</ul>
											<Pagination
												pageInfo={newsDataPage}
												handlePage={handleNewsPage}
											/>
										</>
									) : (
										<p className="no-data">
											{t(
												"pages.investment.InvestListPage.InvestListTable.noData03"
											)}
										</p>
									)}
								</div>
							</Case>
							<Case condition={"similar"}>
								<div className="similar-product">
									{similarProductList.length < 1 ? (
										<p className="no-data">
											{t(
												"pages.investment.InvestListPage.InvestListTable.noData04"
											)}
										</p>
									) : (
										<div className="table">
											<div className="c__table">
												<div className="thead">
													<div className="tr">
														<div className="th company">
															{t(
																"pages.apply.ApplyEval.ApplyEvalTable.company"
															)}
														</div>
														<div className="th product-type">
															{t(
																"pages.investment.InvestListPage.InvestListTable.tableHeading03"
															)}
														</div>
														<div className="th invest-value">
															{t(
																"pages.investment.InvestListPage.SearchFilter.section1.title03"
															)}
														</div>
														<div className="th invest-step">
															{t(
																"pages.investment.InvestListPage.SearchFilter.section1.title01"
															)}
														</div>
														<div className="th tag">
															{t(
																"pages.investment.InvestListPage.InvestListTable.tableHeading04"
															)}
														</div>
													</div>
												</div>
												<div className="tbody">
													{similarProductList.map((product) => (
														<div className="tr">
															<div className="td company">
																<div className="img-wrap">
																	<img
																		src={
																			product.logo_url ||
																			(theme === "dark"
																				? darkLogoImg
																				: lightLogoImg)
																		}
																		alt={t(
																			"pages.portfolio.PortfolioList.components.ListItem.logo"
																		)}
																	/>
																</div>
																<div className="company-detail">
																	<a
																		href={linkAddHttp(
																			product.homepage
																		)}
																		target="_blank"
																		className={
																			linkAddHttp(
																				product.homepage
																			)
																				? ""
																				: "disabled"
																		}
																	>
																		{product.company_name}
																	</a>
																	<span className="company-info">
																		{`${product?.address.split(
																			" "
																		)[0]
																			}/
																		
																		
																		${product.establishment_date
																				? new Date().getFullYear() -
																				toDate(
																					product.establishment_date.substr(
																						0,
																						4
																					)
																				).getFullYear() +
																				t(
																					"pages.portfolio.PortfolioList.components.ListItem.year"
																				)
																				: "- "
																			}/
																		${product.business_category_desc || t("pages.portfolio.PortfolioList.components.ListItem.Info")}`}
																	</span>
																</div>
															</div>
															<div className="td product-type">
																{product.productNameList.length > 0
																	? product.productNameList[0]
																	: "-"}
															</div>
															<div className="td invest-value">
																{product.investValue === "-"
																	? product.investValue
																	: convertToBillion(
																		product.investValue
																	)}
															</div>
															<div className="td invest-step">
																{product.investStep}
															</div>
															<div
																className={`td tag ${product.keywords.length < 1
																	? "none"
																	: ""
																	}`}
															>
																<div className="tagList">
																	{product.keywords.length > 0
																		? product.keywords
																			.split(",")
																			.map(
																				(keyword) =>
																					`#${keyword} `
																			)
																		: " - "}
																</div>
															</div>
														</div>
													))}
												</div>
											</div>
										</div>
									)}
								</div>
							</Case>
						</If>
					</section>
				</div>
			</ModalTemplate>

			<AlertTemplate alertModalState={addModal} setAlertModalToggle={setAddModal}>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.investment.InvestListPage.InvestListTable.alert01")}
					</div>
				</p>
				<div className="alert-footer">
					<button className="btn__solid" color="primary" onClick={setAddModal}>
						{t("pages.investment.InvestListPage.InvestListTable.confirm")}
					</button>
				</div>
			</AlertTemplate>

			<AlertTemplate alertModalState={subModal} setAlertModalToggle={setSubModal}>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.investment.InvestListPage.InvestListTable.alert02")}
					</div>
				</p>
				<div className="alert-footer">
					<button className="btn__solid" color="primary" onClick={setSubModal}>
						{t("pages.investment.InvestListPage.InvestListTable.confirm")}
					</button>
				</div>
			</AlertTemplate>

			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
			<NoInfoAlert
				message={
					<>
						VC정보 작성하지 않은 경우,<br />
						투자심사 요청이 어렵습니다. <br />
						VC정보{'>'}VC소개에서 기업정보(기업명 필수)를 작성해주세요.
					</>
				}
				type="warning"
				confirm="작성하러가기"
				reject="취소"
			/>
		</>
	);
};

export default InvestListTable;
